import { NativeStackScreenProps } from '@react-navigation/native-stack';
import React from 'react';

import SearchModal from '../Components/Modals/SearchModal';
import { RootStackParamList } from '../navigator';

type Props = NativeStackScreenProps<RootStackParamList, 'Search'>;

const SearchScreen: React.FC<Props> = ({ navigation }) => {
	return <SearchModal onClose={() => navigation.goBack()} />;
};

export default SearchScreen;
